import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { StoryblokCdnPipe } from '../../../storyblok/pipes/storyblok-cdn.pipe';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { TooltipContentComponent } from '../tooltip-content/tooltip-content.component';

@Component({
  selector: 'app-product-feature-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContextMenuComponent, TooltipContentComponent, StoryblokCdnPipe],
  templateUrl: './product-feature-tooltip.component.html',
  styleUrl: './product-feature-tooltip.component.scss',
})
export class ProductFeatureTooltipComponent {
  title = input<string>();
  htmlContent = input<string>();
  imageOrVideoUrl = input<string>();
  containsVideo = computed(() => this.imageOrVideoUrl()?.includes('mp4'));
}
